export default {
  title: {
    offerLetter: '我的Offer',
    myOffer: '我的Offer'
  },
  label: {
    downloadTip: '此处下载录用通知书',
    idNumberLabel: '身份证号',
    mobileLabel: '手机号码',
    signLabel: '签署本人姓名',
    rejectCase: '拒绝原因',
    rejectCaseComment: '留言',
    acceptOfferTitle: '接受Offer',
    rejectOfferTitle: '拒绝Offer',
    acceptOfferSuccess: 'Offer已接受！',
    rejectOfferSuccess: 'Offer已拒绝',
    noOfferData: '你还没有任何offer',
    signTip: '签名'
  },
  btn: {
    rejectOffer: '拒绝',
    clearSign: '清除',
    downloadOfferLetter: '下载Offer',
    viewAllOffer: '查看Offer',
    toOperate: '去操作',
    viewDetail: '查看',
    toPersonalHome: '查看个人中心'
  },
  INVITE_STATUS: {
    INVITED: '待操作',
    ACCEPTED: '已接受',
    REJECTED: '已拒绝'
  }
}
